import { render, staticRenderFns } from "./RepaymentDetailInfo.vue?vue&type=template&id=6c232557&scoped=true&"
import script from "./RepaymentDetailInfo.vue?vue&type=script&lang=js&"
export * from "./RepaymentDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c232557",
  null
  
)

export default component.exports